import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import ContentContainer from "../../component/ContentContainer/";
import axios from "axios";
import {ApiUrl} from "../../auth/authMethods";
import {useUser} from "../../auth/AuthProvider";
import {
    Card, CardContent,
    Checkbox,
    Grid, Modal,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {numberWithPoints} from "../../utils/numberWithPoints";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {normalizeTimestemp} from "../../utils/normalizeTimestemp";
import AlertPopup from "../../component/AlertPopup";
import {useNavigate} from "react-router-dom";
import AjustarDesconto from "../../component/AjustarDesconto";

export default function QuitacaoContrato() {
    const [eventos, setEventos] = useState([]);
    const [pedidos, setPedidos] = useState([]);
    const [pagadores, setPagadores] = useState([]);
    const [eventoSelecionado, setEventoSelecionado] = useState("");
    const [pedidoSelecionado, setPedidoSelecionado] = useState("");
    const [pagadorSelecionado, setPagadorSelecionado] = useState("");
    const [rows, setRows] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [titlePopup, setTitlePopup] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState(null);
    const {user} = useUser()
    const nav = useNavigate();
    const [open, setOpen] = useState(false);
    const [tipoDesconto, setTipoDesconto] = useState("porcentagem");
    const [valorDesconto, setValorDesconto] = useState("");
    const [type, setType] = useState("");
    const [onConfirm, setOnConfirm] = useState();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${user?.token}`;
        axios
            .get(`${ApiUrl}/quitacoes/evento-list`)
            .then((response) => {
                setEventos(response.data);
            })
            .catch((err) => {
                console.error("Erro ao buscar eventos:", err);
                setError("Erro ao carregar eventos.");
            });
    }, []);

    const handleEventoChange = (event) => {
        setError([])
        setPedidoSelecionado("")
        setPagadorSelecionado("")
        const eventoId = event.target.value;
        setEventoSelecionado(eventoId);
        setPedidos([]);
        setPagadores([]);

        axios
            .get(`${ApiUrl}/quitacoes/pedido-list?eventoId=${eventoId}`)
            .then((response) => {
                setPedidos(response.data);
            })
            .catch((err) => {
                console.error("Erro ao buscar pedidos:", err);
                setError("Erro ao carregar pedidos.");
            });
    };

    const handlePedidoChange = (event) => {
        const pedidoId = event.target.value;
        setPedidoSelecionado(pedidoId);

        axios
            .get(`${ApiUrl}/quitacoes/pagador-list?pedidoId=${pedidoId}`)
            .then((response) => {
                setPagadores(response.data);
            })
            .catch((err) => {
                console.error("Erro ao buscar pagadores:", err);
                setError("Erro ao carregar pagadores.");
            });
    };

    const handleConfirmarQuitacao = () => {
        if (!eventoSelecionado || !pedidoSelecionado || !pagadorSelecionado) {
            setError("Todos os campos devem ser preenchidos.");
            return;
        }

        try {
            axios.get(`${ApiUrl}/quitacoes/list?userId=${pagadorSelecionado}&pedidoId=${pedidoSelecionado}&page=0&size=1000`)
                .then((response) => {
                    if(response.data.content.length === 0){
                        setError("Pagador sem Parcelas!")
                    } else {
                        setRows(response.data.content);
                    }
                })
                .catch((error) => {
                    console.error("Erro ao carregar os dados da API:", error);
                });
        } catch (error) {
            setError(error.message);
        }
    };

    const [selectedParcelas, setSelectedParcelas] = useState(rows.map((row) => row.id));

    const handleCheckboxChange = (id) => {
        setSelectedParcelas((prevState) =>
            prevState.includes(id)
                ? prevState.filter((parcelaId) => parcelaId !== id)
                : [...prevState, id]
        );
    };

    const handleAdd = () => {
        const nextParcela = rows.find((row) => !selectedParcelas.includes(row.id));
        if (nextParcela) {
            setSelectedParcelas((prevState) => [...prevState, nextParcela.id]);
        }
    };

    const handleRemove = () => {
        setSelectedParcelas((prevState) =>
            prevState.filter((parcelaId) => parcelaId !== prevState[prevState.length - 1])
        );
    };

    const handleCheckAll = () => {
        const allSelected = selectedParcelas.length === rows.length;
        setSelectedParcelas(allSelected ? [] : rows.map((row) => row.id));
    };

    const getTotalAntecipar = () => {
        return selectedParcelas.reduce(
            (total, parcelaId) => total + rows.find((row) => row.id === parcelaId).valor,
            0
        );
    };

    const handleBack = () => {
        setRows([])
    };

    const handleQuitar = async () => {
        if (!selectedParcelas || !Array.isArray(selectedParcelas) || selectedParcelas.length === 0) {
            setType("alert")
            setTitlePopup("Erro ao gerar boleto");
            setMessage("Nenhuma parcela foi selecionada para antecipação.");
            setShowAlert(true);
            return;
        }

        const totalAntecipar = getTotalAntecipar();
        const desconto = valorDesconto != null ? parseFloat(valorDesconto) : 0.00;

        if (desconto < 0) {
            setType("alert")
            setTitlePopup("Erro ao aplicar desconto");
            setMessage("O valor do desconto não pode ser negativo.");
            setShowAlert(true);
            return;
        }

        if (tipoDesconto === "Porcentagem" && desconto > 100) {
            setType("alert")
            setTitlePopup("Erro ao aplicar desconto");
            setMessage("O desconto em porcentagem não pode ser maior que 100%.");
            setShowAlert(true);
            return;
        }

        if (tipoDesconto === "Valor" && desconto > totalAntecipar) {
            setType("alert")
            setTitlePopup("Erro ao aplicar desconto");
            setMessage("O desconto não pode ser maior que o valor total da antecipação.");
            setShowAlert(true);
            return;
        }

        let valorFinal = tipoDesconto === "porcentagem"
            ? (totalAntecipar - (totalAntecipar * desconto / 100))
            : (totalAntecipar - desconto)

        if (valorFinal < 0) {
            setType("alert")
            setTitlePopup("Erro ao aplicar desconto");
            setMessage("O valor final da antecipação não pode ser negativo.");
            setShowAlert(true);
            return;
        }

        const requestData = {
            dtos: selectedParcelas,
            tipo: tipoDesconto.toUpperCase(),
            desconto
        };

        try {
            await axios.post(`${ApiUrl}/quitacoes/register`, requestData);
            setType("success")
            setTitlePopup("Boleto de quitação gerado com sucesso!");
            setMessage("O seu boleto foi gerado com sucesso, por favor valide-o em suas parcelas.");
            setOnConfirm(() => () => nav("/"))
            setShowAlert(true);
        } catch (error) {
            console.error("Erro ao registrar antecipação:", error);
            setType("alert")
            setTitlePopup("Erro ao gerar boleto");
            setMessage("Ocorreu um erro ao tentar gerar o boleto. Tente novamente mais tarde.");
            setShowAlert(true);
        }
    };

    const handleDesconto = () => {

    };


    return (
        <>
            {rows.length === 0 ? (
                <ContentContainer>
                    <Box component="form" sx={{ mt: 1 }}>
                        <div className="text-center">
                            <PriceCheckIcon fontSize="large" sx={{ fontSize: "4rem" }} />
                            <Typography variant="h6" gutterBottom>
                                Deseja realizar a quitação total ou parcial de um contrato?
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                Escolha o Pedido e o Pagador que deseja gerar quitação. Em seguida
                                escolha as parcelas que deseja realizar a quitação.
                            </Typography>
                        </div>

                        {/* Select para eventos */}
                        <Select
                            value={eventoSelecionado}
                            onChange={handleEventoChange}
                            displayEmpty
                            fullWidth
                            sx={{ mb: 2 }}
                        >
                            <MenuItem value="" disabled>
                                Selecione um evento
                            </MenuItem>
                            {eventos.map((evento) => (
                                <MenuItem key={evento.id} value={evento.id}>
                                    {evento.text}
                                </MenuItem>
                            ))}
                        </Select>

                        {/* Select para pedidos */}
                        <Select
                            value={pedidoSelecionado}
                            onChange={handlePedidoChange}
                            displayEmpty
                            fullWidth
                            disabled={!eventoSelecionado}
                            sx={{ mb: 2 }}
                        >
                            <MenuItem value="" disabled>
                                Selecione um pedido
                            </MenuItem>
                            {pedidos.map((pedido) => (
                                <MenuItem key={pedido.id} value={pedido.id}>
                                    {pedido.text}
                                </MenuItem>
                            ))}
                        </Select>

                        {/* Select para pagadores */}
                        <Select
                            value={pagadorSelecionado}
                            onChange={(event) => setPagadorSelecionado(event.target.value)}
                            displayEmpty
                            fullWidth
                            disabled={!pedidoSelecionado}
                            sx={{ mb: 2 }}
                        >
                            <MenuItem value="" disabled>
                                Selecione um pagador
                            </MenuItem>
                            {pagadores.map((pagador) => (
                                <MenuItem key={pagador.id} value={pagador.id}>
                                    {pagador.text}
                                </MenuItem>
                            ))}
                        </Select>

                        {error && <Typography color="error">{error}</Typography>}

                        <Button
                            type="button"
                            variant="contained"
                            fullWidth
                            disabled={!eventoSelecionado || !pedidoSelecionado || !pagadorSelecionado}
                            sx={{ mt: 2 }}
                            onClick={handleConfirmarQuitacao}
                        >
                            Confirmar Quitação
                        </Button>
                    </Box>
                </ContentContainer>
            ) : (
                <Box sx={{ backgroundColor: 'white', padding: 2, display: 'flex', justifyContent: 'center' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Card sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                <CardContent>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item ml={"auto"}>
                                            <Typography variant="h6" color="textSecondary">
                                                Total para realizar
                                            </Typography>
                                            <Typography variant="h6" color="textSecondary">
                                                sua quitação:
                                            </Typography>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <Typography variant="h3" color="inherit">
                                                        R${numberWithPoints(Number(getTotalAntecipar()).toFixed(2))}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Grid container direction="column" alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <IconButton size="large" onClick={handleAdd}>
                                                        <AddIcon />
                                                    </IconButton>
                                                </Grid>
                                                <Grid item>
                                                    <IconButton size="large" onClick={handleRemove}>
                                                        <RemoveIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Card sx={{ width: '100%', margin: "auto", padding: 2, height: 160, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <Button
                                    sx={{ mb: 1, width: "100%", height: 48 }}
                                    color="success"
                                    variant="contained"
                                    onClick={handleQuitar}
                                    disabled={getTotalAntecipar() <= 0}
                                >
                                    QUITAR
                                </Button>
                                <Button
                                    sx={{ mt: 1, width: "100%", height: 48 }}
                                    color="warning"
                                    variant="contained"
                                    onClick={handleBack}
                                >
                                    Voltar para escolha de lote
                                </Button>
                            </Card>
                        </Grid>
                        <Grid item xs={12}>
                            <Card sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                <CardContent sx={{ width: '100%' }}>
                                    <Typography variant="h6" gutterBottom sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        Parcelas que serão antecipadas
                                        <Box sx={{ marginLeft: 1 }}>
                                            <Button
                                                variant={"contained"}
                                                color={"success"}
                                                onClick={handleCheckAll}
                                            >
                                                {selectedParcelas.length === rows.length
                                                    ? "Desmarcar Todas"
                                                    : "Marcar Todas"
                                                }
                                            </Button>
                                        </Box>
                                        <Box sx={{ marginLeft: 1 }}>
                                            <Button variant="contained" color="primary" onClick={handleOpen}>
                                                Ajustar Desconto
                                            </Button>
                                        </Box>
                                        <Modal open={open} onClose={handleClose}>
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    width: 400,
                                                    bgcolor: "background.paper",
                                                    border: "2px solid #000",
                                                    boxShadow: 24,
                                                    p: 4,
                                                }}
                                            >
                                                <AjustarDesconto
                                                    onClose={handleClose}
                                                    tipoDesconto={tipoDesconto}
                                                    setTipoDesconto={setTipoDesconto}
                                                    valorDesconto={valorDesconto}
                                                    setValorDesconto={setValorDesconto}
                                                />
                                            </Box>
                                        </Modal>
                                    </Typography>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center"><b>Evento</b></TableCell>
                                                    <TableCell align="center"><b>Lote</b></TableCell>
                                                    <TableCell align="center"><b>Parcela</b></TableCell>
                                                    <TableCell align="center"><b>Valor</b></TableCell>
                                                    <TableCell align="center"><b>Data de Vencimento</b></TableCell>
                                                    <TableCell align="center"><b>Selecionar</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">{row.evento}</TableCell>
                                                        <TableCell align="center">{row.lote}</TableCell>
                                                        <TableCell align="center">{row.parcela}</TableCell>
                                                        <TableCell align="center">{row.valor}</TableCell>
                                                        <TableCell align="center">{normalizeTimestemp(row.vencimento)}</TableCell>
                                                        <TableCell align="center">
                                                            <Checkbox
                                                                checked={selectedParcelas.includes(row.id)}
                                                                onChange={() => handleCheckboxChange(row.id)}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            )}

            <AlertPopup
                type={type}
                title={titlePopup}
                message={message}
                showPopup={showAlert}
                setShowPopup={setShowAlert}
                onConfirm={onConfirm}
            />
        </>
    );
}
